import React, { useEffect } from "react";
import { Popover } from "@headlessui/react";
import Button from "../Button";
import { DocumentMinusIcon } from "@heroicons/react/24/solid";
import tableIcons from "./MaterialTableIcons";
import {
  TablePagination,
  TablePaginationTypeMap,
  TablePaginationBaseProps,
} from "@material-ui/core";
import CustomLoader from "../CustomLoader";
import MaterialTable, {
  MaterialTableProps,
  MTableToolbar,
} from "material-table";
import { useRecoilState } from "recoil";
import DeactivateButton from "../DeactivateButton";

const defaultHeaderStyle = {
  backgroundColor: "#fff",
  color: "#203A75",
  fontWeight: "bold",
  fontSize: "12px",
} as React.CSSProperties;

interface ITablePagination
  extends TablePaginationTypeMap<TablePaginationBaseProps, React.ElementType> {
  ActionsComponent?: any[];
  onChangePage?: any[];
  onChangeRowsPerPage?: any;
}

const PatchedPagination: React.FC<ITablePagination> = ({
  ActionsComponent,
  onChangePage,
  onChangeRowsPerPage,
  ...tablePaginationProps
}) => {
  return (
    <TablePagination
      {...tablePaginationProps}
      // @ts-expect-error onChangePage was renamed to onPageChange
      onPageChange={onChangePage}
      SelectProps={{
        IconComponent: () => <div></div>,
      }}
      onRowsPerPageChange={onChangeRowsPerPage}
      ActionsComponent={(subprops) => {
        const { onPageChange, ...actionsComponentProps } = subprops;

        return (
          // @ts-expect-error ActionsComponent is provided by material-table
          <ActionsComponent
            {...actionsComponentProps}
            onChangePage={onPageChange}
          />
        );
      }}
    />
  );
};
interface IMaterialTableEmployees extends MaterialTableProps<object> {
  isHideEmpPagerow: boolean;
  selectedRows?: any;
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>;
  title?: any;
  tableRef?: any;
  isLoading?: boolean;
  detailPanel?: any;
  toolbar?: any;
  showTitle?: boolean;
  padding?: "default" | "dense";
  exportButton?: boolean;
  searchFieldAlignment?: "left" | "right";
  toolbarButtonAlignment?: "left" | "right";
  paging?: boolean;
  pageSize?: number;
  grouping?: boolean;
  search?: boolean;
  fileName?: string;
  headerStyle?: React.CSSProperties;
  panelWidth?: string;
  selection?: boolean;
  isActive?: boolean;
  isFreeAction?: boolean;
  onSelectionChange?: ((data: any[], rowData?: any) => void) | undefined;
  toolBarComponent?: string;
  onSearchChange?: (searchText: string) => void | undefined;
  searchAutoFocus?: boolean;
  onOrderChange?: (orderBy: number, orderDirection: "desc" | "asc") => void;
}
const MaterialTableEmployees: React.FC<IMaterialTableEmployees> = ({
  selectedRows = [],
  setOpenModal,
  title,
  columns,
  data,
  editable,
  actions,
  tableRef,
  isLoading,
  detailPanel,
  toolbar,
  showTitle = false,
  padding = "dense",
  exportButton,
  searchFieldAlignment = "left",
  toolbarButtonAlignment = "right",
  paging = true,
  pageSize = 10,
  grouping,
  search,
  fileName,
  headerStyle = defaultHeaderStyle,
  panelWidth,
  selection,
  isActive = true,
  onSelectionChange,
  toolBarComponent,
  onSearchChange,
  searchAutoFocus = false,
  onOrderChange,
  isHideEmpPagerow,
}) => {
  return (
    <div className="">
      {selectedRows.length > 0 ? (
        <Popover className="m-2 rounded-lg  ">
          <div className="flex justify-start">
            <DeactivateButton
              className={""}
              onClickFunction={() => {
                setOpenModal && setOpenModal(true);
              }}
              disabled={false}
            >
              <>
                <DocumentMinusIcon className="h-4 w-4 font-bold " />
                Deactivate
              </>
            </DeactivateButton>
            <div className="mt-1 ml-2 text-xs text-primary ">
              Deactivate Selected Row/s
              <p className="inline-block font-bold">
                &nbsp;({selectedRows.length})
              </p>
            </div>
          </div>
        </Popover>
      ) : (
        // </Popover>
        ""
      )}
      <div className={isHideEmpPagerow ? "hide-page-row" : ""}>
        <MaterialTable
          title={title}
          columns={columns}
          data={data}
          editable={editable}
          actions={actions}
          tableRef={tableRef}
          isLoading={isLoading}
          icons={tableIcons}
          detailPanel={detailPanel}
          localization={{
            body: {
              emptyDataSourceMessage: isLoading ? (
                <CustomLoader />
              ) : (
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  No records to display.
                </label>
              ),
              addTooltip: "",
              editTooltip: "",
              deleteTooltip: "",
              editRow: {
                cancelTooltip: "",
                saveTooltip: "",
              },
            },
            toolbar: {
              exportTitle: "Export",
              exportAriaLabel: "Export",
            },
          }}
          options={{
            //tableLayout: tableLayout,
            toolbar: toolbar,
            showTitle: showTitle,
            padding: padding,
            exportButton: exportButton
              ? { csv: exportButton, pdf: false }
              : false,
            searchFieldAlignment: searchFieldAlignment,
            toolbarButtonAlignment: toolbarButtonAlignment,
            paging: data?.length > 0 ? paging : false,
            pageSize: pageSize,
            pageSizeOptions: [3, 5, 10, 15, 20, 30, 100],
            grouping: grouping,
            search: search,
            searchAutoFocus: searchAutoFocus,
            exportFileName: fileName,
            exportAllData: true,
            headerStyle: headerStyle,
            rowStyle: (rowData) => ({
              backgroundColor: rowData.tableData.showDetailPanel
                ? "#F0F4F5"
                : "#FFF",

              color: "#000000",
              opacity: rowData.tableData.showDetailPanel ? "100" : "20",
              fontWeight: "normal",
              fontSize: "13px",
            }),
            detailPanelType: "single",
            detailPanelColumnStyle: { maxWidth: panelWidth ? panelWidth : 25 },
            selection: selection,
            loadingType: "overlay",
            showTextRowsSelected: false,
            emptyRowsWhenPaging: false,
            selectionProps: isActive
              ? (rowData) => {
                  const checked = rowData.tableData.checked
                    ? rowData.isActive || rowData.isActive !== "Inactive"
                      ? { checked: true }
                      : { checked: false }
                    : {};
                  return {
                    disabled:
                      !rowData.isActive || rowData.isActive === "Inactive",
                    ...checked,
                  };
                }
              : (rowData) => {
                  const checked = rowData.tableData.checked
                    ? rowData.isActive !== "Inactive"
                      ? { checked: true }
                      : { checked: false }
                    : {};
                  return {
                    disabled: rowData.isActive === "Inactive",
                    ...checked,
                  };
                },
            addRowPosition: "first",
            actionsColumnIndex: -1,
          }}
          onSearchChange={onSearchChange}
          onOrderChange={onOrderChange}
          onSelectionChange={(rows) => {
            onSelectionChange && onSelectionChange(rows);
          }}
          style={{
            display: "grid",
          }}
          components={{
            Pagination: PatchedPagination,
            OverlayLoading: () => <></>,
            Toolbar: (props) =>
              toolBarComponent ? (
                <div className="flex flex-row w-full ">
                  {toolBarComponent}
                  <div className="w-full">
                    <MTableToolbar {...props} />
                  </div>
                </div>
              ) : (
                <div>
                  <MTableToolbar {...props} />
                </div>
              ),
          }}
        />
      </div>
    </div>
  );
};

export default MaterialTableEmployees;
